package devxertech.com.pages.services.aiDevelopmentService

import androidx.compose.runtime.Composable
import devxertech.com.seo.PageMetadata
import devxertech.com.seo.PageSeo
import devxertech.com.seo.AiServicesJsonLd
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.CommonAboutSection
import devxertech.com.pages.commons.CommonArrow
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.MakeYourOwnTeam
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.services.aiDevelopmentService.aiDevelopmentProcess.AiDevelopmentProcess
import devxertech.com.pages.services.aiDevelopmentService.aiDevelopmentTool.AiDevelopmentTool
import devxertech.com.pages.services.aiDevelopmentService.developmentServices.AiServices
import devxertech.com.pages.services.aiDevelopmentService.AiServiceUseCases
import devxertech.com.pages.services.aiDevelopmentService.AiServiceDeliveryProcess
import devxertech.com.pages.services.aiDevelopmentService.AiServiceFaq
import devxertech.com.pages.services.aiDevelopmentService.AiServiceContactCta
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/ai-services")
@Composable
fun AiDevelopmentServices(){
    PageMetadata(PageSeo.Ai)
    AiServicesJsonLd()
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()
    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
//
        CommonHeader(
            imageAlt = "Illustration for AI assistant and automation development",
            mainHeadingAsH1 = true,
            image = Res.Image.ai_Development_header,
            breakpoint = breakpoint,
            headingText = "AI Assistant & Automation Development",
            descriptionText = "Help your team find information, handle routine tasks and work more efficiently. We build AI assistants and automation around your business documents, tools and workflows, starting with a clearly defined problem and practical project scope."
        )
//
        CommonArrow("Al Development")
//
//        AiDevelopmentAbout(breakpoint, sitePalette)
        CommonAboutSection(
            breakpoint =   breakpoint,
            title = "AI for everyday work",
            firstFont = "Assistants,",
            secondFont = "Search & Automation",
            description = "Start with a clearly defined task: help employees find approved information, search and summarise documents, or reduce repetitive steps across existing tools. We review the available data, access permissions and integration options before agreeing on a focused scope. Human review remains part of workflows where decisions need it.",
            imageName = Res.Image.ai_Development_about,
            imageAlt = "AI development illustration representing business knowledge and automation"
        )
//
        AiServices(breakpoint, sitePalette)
//
        AiServiceUseCases(breakpoint, sitePalette)
//
        AiDevelopmentProcess(breakpoint, sitePalette)
//
        AiServiceDeliveryProcess(breakpoint, sitePalette)
//
        AiServiceFaq(breakpoint, sitePalette)
//
        AiServiceContactCta(breakpoint, sitePalette)
//
        MakeYourOwnTeam(breakpoint)
//
        AiDevelopmentTool(breakpoint, sitePalette, text = "AI DEVELOPMENT")
//
        RatingSection(breakpoint)
//
        HomepageFooter(breakpoint)
    }
}
